export const SUPPORT_EMAIL = 'zoediagnostics@muditastudios.com';

export function supportMailto(subject: string, body: string): string {
  return `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject || 'Help with Zoe')}&body=${encodeURIComponent(body)}`;
}

// Routes whose first path segment is followed by a bearer-style token.
// /magic-link carries its token in the query string, which redactUrl drops.
const TOKEN_PATH_ROUTES = new Set(['share', 'invite', 'survey', 'founder-followup', 'join']);

function redactPathname(pathname: string): string {
  const segments = pathname.split('/').filter(Boolean);
  if (segments.length >= 2 && TOKEN_PATH_ROUTES.has(segments[0])) {
    segments[1] = '<redacted>';
  }
  return `/${segments.join('/')}`;
}

function redactUrl(href: string): string {
  try {
    const url = new URL(href);
    const query = url.search ? '?<redacted>' : '';
    return `${url.origin}${redactPathname(url.pathname)}${query}`;
  } catch {
    return '(url unavailable)';
  }
}

export interface SupportContext {
  route?: string;
  errorName?: string;
  errorMessage?: string;
  errorId?: string;
}

const MAX_DETAIL = 300;

export function buildSupportContext(ctx: SupportContext = {}): string {
  const lines: string[] = [];
  if (typeof window !== 'undefined') {
    lines.push(`URL: ${redactUrl(window.location.href)}`);
    lines.push(`UA: ${navigator.userAgent}`);
  }
  if (ctx.route) {
    const [pathname, query] = ctx.route.split('?');
    lines.push(`Route: ${redactPathname(pathname)}${query !== undefined ? '?<redacted>' : ''}`);
  }
  if (ctx.errorId) lines.push(`Error id: ${ctx.errorId}`);
  if (ctx.errorName) lines.push(`Error: ${ctx.errorName}`);
  if (ctx.errorMessage) {
    const detail =
      ctx.errorMessage.length > MAX_DETAIL ? `${ctx.errorMessage.slice(0, MAX_DETAIL)}…` : ctx.errorMessage;
    lines.push(`Detail: ${detail}`);
  }
  if (lines.length === 0) return '';
  return `\n\n---\nContext\n${lines.join('\n')}`;
}
